import React from 'react';
import { CloseSvg } from './Svgs';

import './MobileCloseButton.scss';

const MobileCloseButton = ({ onClick, style, increaseClickableArea }) => (
  <div
    className="mobile-close-button-container"
    onClick={onClick}
    role="presentation"
    style={style}
  >
    <CloseSvg />
    {increaseClickableArea ? (
      <div className="mobile-close-button-inner-container" />
    ) : null}
  </div>
);

export default MobileCloseButton;
